import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { Observable, takeUntil } from 'rxjs';
import {
  CustomResultOfPaginatedListOfGetCustomerClubDeviceNumbersWIthPaginationDto,
  GetCustomerClubDeviceNumbersWIthPaginationDto,
  GetEnumValuesDto,
} from 'src/app/core/api/models';
import { CustomerClubDeviceNumbersService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';

import { PageNames } from 'src/app/configs/page-names.enum';
import { TranslationService } from 'src/app/i18n';
import {
  BaseIndexModule,
  BaseIndexPageComponent,
} from 'src/app/pages/shared/base';

@Component({
  selector: 'app-customer-club-device-numbers',
  imports: [BaseIndexModule],
  templateUrl: './customer-club-device-numbers.component.html',
})
export class CustomerClubDeviceNumbersComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  protected currentService = inject(CustomerClubDeviceNumbersService);
  @Input() customerClubDeviceId;
  pageName = PageNames.customerClubDeviceNumbers;
  modelWithPagination$: Observable<CustomResultOfPaginatedListOfGetCustomerClubDeviceNumbersWIthPaginationDto>;
  items$: Observable<Array<GetCustomerClubDeviceNumbersWIthPaginationDto>>;
  SmsAggregatorsEnumValues: GetEnumValuesDto[] = [];
  @Output('closePage') output_closePage = new EventEmitter<boolean>();

  //#endregion

  constructor(public translationService: TranslationService) {
    super();
  }

  ngOnInit() {
    try {
      this.location.go(window.location.pathname);
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.tableConfig.showOperationColumn = false;
      this.pageConfig.showRefreshBtn = true;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsAggregator')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => {
        this.SmsAggregatorsEnumValues = values;
      });
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs + 'fields.';

    this.tableColumns = [
      {
        title: this.localizer.mobile,
        name: 'cellPhone',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: 'common.operator',
        name: 'mobileOperator',
        type: 'enum',
        enumName: 'SmsAggregator',
        hasSearch: true,
      },
      {
        title: 'common.histories',
        name: 'histories',
        noSorting: true,
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetCustomerClubDeviceNumbersWIthPaginationDto> {
    return this.currentService.customerClubDeviceNumbersGetCustomerClubDeviceNumbersWIthPagination(
      {
        body: {
          ...this.getBaseModelWithPaginationParams(),
          customerClubDeviceId: this.customerClubDeviceId,
        },
      }
    );
  }

  onBack() {
    this.output_closePage.emit(true);
  }
}
